var map = {
	"./de/namespaces/notificationCenter.js": [
		71841,
		4057
	],
	"./en/namespaces/notificationCenter.js": [
		48905
	],
	"./es/namespaces/notificationCenter.js": [
		90638,
		9102
	],
	"./fr/namespaces/notificationCenter.js": [
		66870,
		2358
	],
	"./it/namespaces/notificationCenter.js": [
		53407,
		1439
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98679;
module.exports = webpackAsyncContext;